
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  Candidate,
  CandidateResult,
  ReportShowConfigV5Item
} from "@/lib/model/exam/result";
import EyeColor from "./eye-color.vue";

enum cheatEnum {
  "eyeColor" = "辨色检测"
}

const cheatKeys = ["eyeColor"];

//异常项 默认文案
const errorEnumText = ["未检测", "未通过", "通过"];
//异常项 对应文案 详情用
const errorEnumTextEX = {
  eyeColor: ["未进行辨色检测", "辨色检测异常", "通过"]
};

@Component({
  components: {
    EyeColor
  }
})
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new Candidate() }) candidate!: Candidate;
  @Prop({ default: () => new CandidateResult() }) all!: CandidateResult;
  @Prop({ default: false }) pdfIng!: boolean;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;
  connectCode = "";
  bgCheckList: any = [];

  get colorAnswer() {
    return (
      this.all.answerList.find(item => item.type === 102) ||
      ({ isAnswered: 0, type: 0, blindnessResult: 0, weaknessResult: 0 } as any)
    );
  }

  @Watch("all")
  getAll(nval: CandidateResult) {
    this.getBgCheckList();
  }

  created() {
    //
    // this.getCheatList()
  }

  //
  mounted() {
    this.getBgCheckList();
    // this.connectCode = this.$route.query.connectCode as string;
    // this.isStudent = String(this.$route.query.ver || "") === "1";
  }

  getColorText() {
    if (this.colorAnswer.colorQuestionAnswerResult.blindnessResult === 2) {
      return "色盲";
    } else if (
      this.colorAnswer.colorQuestionAnswerResult.weaknessResult === 2
    ) {
      return "色弱";
    } else {
      return "";
    }
  }

  getBgCheckList() {
    this.bgCheckList = [];
    this.all.errorInfoList.forEach(item => {
      if (cheatKeys.includes(item.task)) {
        this.bgCheckList.push({
          name: cheatEnum[item.task],
          type: item.result,
          task: item.task,
          result: this.getColorText() || errorEnumText[item.result], //结果
          //原因详情
          value:
            item.resMessage ||
            errorEnumTextEX?.[item.task]?.[item.result] ||
            errorEnumText[item.result]
        });
      }
    });
  }

  async wait(secends: number) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true);
      }, secends);
    });
  }
}
